/// <reference path="../../node_modules/@types/jquery/index.d.ts" />
/// <reference path="../../node_modules/@types/google.analytics/index.d.ts" />
/// <reference path="../../node_modules/@types/bootstrap/index.d.ts" />
/// <reference path="../../node_modules/@types/jquery.colorbox/index.d.ts" />

module DBS.Opportunities
{
    function checkAutoPlay(buttonId: string)
    {
        if (location.search.toLowerCase().indexOf("autoplay") !== -1)
        {
            $(buttonId).click();
        }
    }

    export function Initialize(ev: Event)
    {
        function pushDataLayerEvent(data: any)
        {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(data);
            console.log(data);
        }

        if (document.location.hash.length > 0)
        {
            $(`.navbar-opps a[href$='${document.location.hash}']`).tab("show");
        }

        $(".daily-mail-link")
            .click((event) =>
            {
                event.preventDefault();
                $("a[rel=gallery]")
                    .colorbox({
                        open: true
                    });

                ga("send", "event", "Head Office", "Franchise Opportunity", "Oven Wizards in the Daily Mail");
                pushDataLayerEvent({ "event": "franchise_opportunity_daily_mail" });
            });

        $("a[rel=youtube]")
            .colorbox({
                iframe: true,
                innerWidth: 600,
                innerHeight: 480,
                maxWidth: "100%",
                maxHeight: "100%",
                current: "video {current} of {total}"
            });

        $("a[rel=youtube]")
            .click((event) =>
            {
                const altText = $(event.currentTarget).find("img").attr("alt");

                ga("send", "event", "Head Office", "Franchise Opportunity", `Video - ${altText}`);
                pushDataLayerEvent({ "event": "franchise_opportunity_video", "video_name": altText });
            });

        $("#page-navigation a[href*='#tab_']")
            .click((event) =>
            {
                let link = (event.currentTarget as HTMLAnchorElement).href;
                link = link.substring(link.indexOf("#"));
                location.hash = link;

                let text = (event.currentTarget as HTMLAnchorElement).text;
                ga("send", "event", "Head Office", "Franchise Opportunity", `Tabs - ${text}`);
                pushDataLayerEvent({ "event": "franchise_opportunity_tabs", "tab_name": text });
            });


        $("a.tel-link")
            .click((event) =>
            {
                ga("send", "event", "Head Office", "Franchise Opportunity", "Clicked to call");
            });

        $(".prospectus-form input[type=submit]")
            .click((event) =>
            {
                ga("send", "event", "Head Office", "Franchise Opportunity", "Downloaded Franchise Prospectus");
                pushDataLayerEvent({ "event": "form_submission", "form_name": "Download Franchise Prospectus" });
            });

        checkAutoPlay("#main-video");
    }
}

window.addEventListener("load", DBS.Opportunities.Initialize);